/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from '@reduxjs/toolkit';
import { BlogModel } from '@app/model/BlogModel';
import { createBlogApi, deleteBlogApi, getBlogsApi, updateBlogApi } from '@app/api/blog.api';
import { AppDispatch, Callback } from '../store';
import { getObjectKeys } from '@app/utils/utils';

const initialState: Record<string, BlogModel> = {};

export const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    addBlog: (state, action) => {
      state[action.payload.uuid] = action.payload;
      return state;
    },
    listBlog: (state, action) => {
      state = {};
      for (const obj of action.payload) {
        state[obj.uuid] = obj;
      }
      return state;
    },
    removeBlog: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateBlog: (state, action) => {
      state[action.payload.uuid] = {
        ...state[action.payload.uuid],
        ...action.payload,
      };
      return state;
    },
  },
});

const { addBlog, updateBlog, listBlog, removeBlog } = blogSlice.actions;

export const createAsyncBlog =
  (data: BlogModel, callback: Callback, onError: Callback) => async (dispatch: AppDispatch) => {
    try {
      const toSave = new FormData();
      const image = data.image;

      const keysData: Array<keyof BlogModel> = getObjectKeys(data);

      keysData
        .filter((val: any) => val !== 'image')
        .forEach((key) => {
          toSave.append(key, '' + data[key]);
        });

      toSave.append('imageFile', image);
      createBlogApi(toSave)
        .then((res) => {
          dispatch(addBlog(res));
          callback?.();
        })
        .catch((error) => {
          console.log('create blog error', error);
          onError?.();
        });
    } catch (error) {
      onError?.();
    }
  };

export const updateAsyncBlog =
  (data: BlogModel, callback: Callback, onError: Callback) => async (dispatch: AppDispatch) => {
    try {
      const toSave = new FormData();
      const image = data.image;

      const keysData: Array<keyof BlogModel> = getObjectKeys(data);

      keysData
        .filter((val: any) => !['image', 'images', 'createdAt', 'imageMediaId', 'imageUrl', 'imageFile'].includes(val))
        .forEach((key) => {
          toSave.append(key, '' + data[key]);
        });

      if (image && image !== 'null') {
        toSave.append('imageFile', image);
      } else {
        toSave.append('imageFile', new Blob());
      }

      if (data?.imageMediaId && data?.imageMediaId !== 'null') {
        toSave.append('imageMediaId', data.imageMediaId);
      }

      updateBlogApi(toSave)
        .then((res) => {
          dispatch(updateBlog(res));
          callback?.();
        })
        .catch((error) => {
          console.log('update blog error', error);
          onError?.();
        });
    } catch (error) {
      onError?.();
    }
  };

export const listAsyncBlogs = () => async (dispatch: AppDispatch) => {
  try {
    const res = await getBlogsApi();
    dispatch(listBlog(res));
  } catch (error) {
    console.log('list blogs error', error);
  }
};

export const deleteAsyncBlog = (id: string, callback: Callback, onError: Callback) => async (dispatch: AppDispatch) => {
  try {
    deleteBlogApi(id)
      .then(() => {
        dispatch(removeBlog(id));
        callback?.();
      })
      .catch((error) => {
        console.log('delete blog error', error);
        onError?.();
      });
  } catch (error) {
    onError?.();
  }
};

export default blogSlice.reducer;
